// Modules
import styled from 'styled-components'

export const ModalContainer = styled.div`
    & > div {
        z-index: 2;
    }

    & span {
        cursor: pointer;
    }
`

export const ModalWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    @media only screen and (min-device-width: 320px) and (max-device-width: 480px) and (-webkit-min-device-pixel-ratio: 2) {
        justify-content: flex-start;
    }
`

export const ModalImg = styled.img`
    height: 148px;
    width: 148px;
`

export const ModalContent = styled.div`
    margin: 1em 1em 1.5em 1em;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;

    & .modal__title {
        margin-bottom: 16px;
        font-weight: 700;
        font-size: 33px;
        line-height: 32px;
    }

    & .modal__subtitle {
        font-size: 16px;
        line-height: 24px;
    }

    button {
        margin-top: 32px;
        width: 100%;
    }

    @media only screen and (min-device-width: 320px) and (max-device-width: 480px) and (-webkit-min-device-pixel-ratio: 2) {
        & .modal__title {
            margin-bottom: 16px;
            font-weight: 700;
            font-size: 33px;
            line-height: 32px;
        }

        button {
            margin-top: 84px;
            width: 100%;
        }
    }
`
